export default __webpack_public_path__ + "static/media/timon.2080100a.jpeg";